














































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import SpecialProjectAddInfo from '../specialProjectAddInfo.vue'
@Component({
    name:'specialProjectDetail',
    components: {
        SpecialProjectAddInfo
    }
})
export default class SpecialProjectDetail extends AbpBase  {
    initData:any = {
        loading: true,
        resData: {},
        modalData: {
            status: false,
            loading: true
        },
        verifyData: {
            status: false
        }
    }
    //编辑
    Edit(type:boolean) {
        this.initData.modalData.status = type;
    }
    //审核
    async Audit(type:any) {
        let data:any = {
            id: this.initData.resData.id,
            isPass: !!type,
        };
        this.initData.verifyData.status = false;
        if(type){
            await Ajax.post('/api/services/app/ResearchProject/AuditProjectAsync', data).then((res:any)=>{
                this.$Modal.success({
                    title: '创新引导项目审核',
                    content: '项目审核已通过！'
                });
                this.GetData();
            });
        }else{
            this.$Modal.confirm({
                title: '创新引导项目审核',
                content: '确定要驳回该项目吗？',
                onOk: async ()=>{                        
                    await Ajax.post('/api/services/app/ResearchProject/AuditProjectAsync', data);
                    this.$Message.success('操作成功!');
                    this.GetData();
                }
            })
        }
    }
    editChange(){
        this.GetData();
    }
    //重置月份弹窗loading
    resetMonthLoading() {
        setTimeout(() => {
            this.initData.modalData.loading = false;
            this.$nextTick(() => {
                this.initData.modalData.loading = true;
            });
        }, 1000);
    }
    //重置弹窗
    ResetForm(type:any) {
        if(!type){
            (this as any).$refs.SpecialProjectAdd.ResetForm();
        }
    }
    //项目提交
    Submit() {
        (this as any).$refs.SpecialProjectAdd.Submit('edit');
    }
    GetData() {
        this.initData.loading = true;
        Ajax.get('/api/services/app/ResearchProject/GetCXProjectDetailAsync?Id='+this.initData.id).then((res:any)=>{
            this.initData.resData = res.data.result;
            (this.$parent as any).SetName(res.data.result.projectName);
            this.initData.loading = false;
        })
    }
    mounted() {
        this.initData.id = this.$route.query.id;
        this.GetData();
    }
}
